export function checkCurrentURL(setOfApprovedUrl, currentUrl) {
  return setOfApprovedUrl.some((approvedUrl) => {
    // Check if the current URL starts with the approved URL
    return currentUrl.startsWith(approvedUrl);
  });
}
